<template>
  <div class="field" :class="question.errorMessage ? 'errorBorder' : ''">
    <div class="field-label title_text">
      {{ question.num }}、<span v-html="question.title"></span>
      <span v-if="question.must === 1" class="req">*</span>
    </div>
    <div class="scale-div" style="padding:0 5px;">
      <table class="scale-rating">
        <thead>
        <tr class="normalTr">
          <th v-for="(item,index) in arrOption" :key="index">
            {{ item }}
          </th>
        </tr>
        </thead>
        <tr>
          <td v-for="(item,index) in arrOption.length"  :key="index"
              @click="selectCurrent(question.num, index ,question)">
            <a class="rate-off" :class=" selected[index] ? 'rate-on' : '' ">{{ item }}</a>
          </td>
        </tr>
      </table>
    </div>
    <div class="errorMessage">{{ question.errorMessage }}</div>
  </div>
</template>
<script>
export default {
  props: {
    question: Object
  },
  data() {
    return {
      answer: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      selected: [false, false, false, false, false, false, false, false, false]
    }
  },
  computed: {
    arrOption() {
      return this.question.fixArr.split(',');
    }
  },
  created() {
    const question = this.question;
    if (question.answer !== undefined && question.answer !== null && typeof question.answer === "number") {
        this.$set(this.selected, question.answer - 1, true);
    }
  },
  methods: {
    selectCurrent(num, i, question) {
      let self = this
      self.selected.map(function (item, index) {
        if (index === i) {
          self.$set(self.selected, index, true)
        } else {
          self.$set(self.selected, index, false)
        }
      })
      question.finish = 1;
      question.answer = (i + 1);
      question.errorMessage = ''
      self.$emit('listenToChildEvent', num, i + 1, question)
    }
  }
}
</script>
<style lang="stylus" scoped>
table {
  width: 100%;
  background-color: #ffffff;
}

table th {
  padding: 0.16rem 0;
  width: 9%;
  text-align: center;
  font-weight: normal;
}

table th:first-child, table th:last-child {
  width: 14%;
}

table td {
  border-top: 1px solid #dbdbdb;
  padding: 0.2rem 0;
  text-align: center;
}

.rate-off {
  width: 21px;
  height: 21px;
  text-decoration: none;
  border-radius: 30px;
  color: #333;
  border: 1px solid #cacece;
  cursor: default;
  display: inline-block;
  background: #fafafa;
  line-height: 19px;
  text-align: center;
}

.rate-on {
  background-color: #53a4f4 !important;
  border: 1px solid #53a4f4;
  position: relative;
  color: #fff;
}

.req {
  color: red
}

.title_text {
  font-weight: bold;
}
</style>
